import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import AddOnList from '../component/AddOnList';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import PaginationComponenent from '../component/Pagination';
import Constants, { LIMIT } from '../utils/Constants';
import { toast } from 'react-toastify';
import RoutePath from '../utils/routes/RoutePath';
import { getSavedPage, setSavedPage } from '../utils/paginationState';

const PAGINATION_KEY = 'admin-addon-list';

class AdminAddOnList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pageNumber: getSavedPage(PAGINATION_KEY),
            totalItem: '',
            isVendor: false,
            isLoading: false
        }
    }
    componentDidMount() {
        const Agent = this.props.match.path.split('/')
        if (Agent[2] === "addon" && Agent[1] === "admin") {
            this.setState({ isVendor: true })
        } else {
            this.setState({ isVendor: false })
        }
        this.getAddOn()
    }

    getAddOn = () => {
        const{pageNumber}=this.state
        let params = {
            limit: LIMIT,
            pageNumber: pageNumber-1
        }
        const callback = (response) => {
            this.setState({ isLoading: false })
            if (response) {
                this.setState({ totalItem: response.response.totalItems })
            }
        }
        this.setState({ isLoading: true })
        this.props.getAddOnList(params, callback, (this.props.location.pathname === RoutePath.ADDON_LIST))
    }
    onChangePagination = (pageNumber) => {
        let params = {
            limit: LIMIT,
            pageNumber: (pageNumber - 1)
        }
        const callback = (response) => {
            this.setState({ isLoading: false })
        }
        this.setState({ isLoading: true })
        this.props.getAddOnList(params, callback, (this.props.location.pathname === RoutePath.ADDON_LIST))
        setSavedPage(PAGINATION_KEY, pageNumber);
        this.setState({ pageNumber: pageNumber })
    }
    updateStatus = (id, active) => {
        const updateParams = {
            id,
            isActive: active ? 0 : 1
        }
        const callback = (response) => {
            this.setState({ isLoading: false })
            if (response.response_code === 0) {
                toast.success(Constants.UPDATED_SUCCESSFULLY)
                this.getAddOn()
            }
            else {
                toast.error(response.response_message)
            }
        }
        this.setState({ isLoading: true })
        this.props.updateAddOnDetails(updateParams, callback, true)
    }
    render() {
        const { pageNumber, totalItem, isVendor, isLoading } = this.state;
        const { getAddOn = {} } = this.props
        const { data } = getAddOn
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <AddOnList addonList={data?.addons} updateStatus={(id, active) => this.updateStatus(id, active)} getAddonList={this.getAddOn}
                            isVendor={isVendor}
                            currentPage={pageNumber} />
                        <div className='page-content'>
                            {
                                data?.totalItems > (LIMIT - 1) ? <PaginationComponenent currentPage={pageNumber} countValue={data?.totalItems} onChangeHandle={this.onChangePagination} /> : ''
                            }
                        </div>
                    </div>
                </div>

                {isLoading && <AppLoader />}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getAddOn: Actions.getAddOn(state)
    }
};
export default withRouter(connect(mapStateToProps, {
    getAddOnList: Actions.getAddOnList,
    updateAddOnDetails: Actions.updateAddOn,
})(AdminAddOnList));